import axios from "axios";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ListGambarDepan = () => {
  const [gambarList, setGambarList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGambar = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/gambardepan`
      );
      setGambarList(res.data);
    } catch (err) {
      toast.error("Gagal memuat gambar depan.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const konfirmasi = window.confirm("Yakin ingin menghapus gambar ini?");
    if (!konfirmasi) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/gambardepan/${id}`
      );
      toast.success("Gambar berhasil dihapus.");
      fetchGambar(); // Refresh data
    } catch (err) {
      toast.error("Gagal menghapus gambar.");
    }
  };

  useEffect(() => {
    fetchGambar();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <ToastContainer />
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-semibold mb-6 text-center">
          Daftar Gambar Depan Sekolah
        </h2>

        {loading ? (
          <p className="text-center text-gray-600">Memuat gambar...</p>
        ) : gambarList.length === 0 ? (
          <p className="text-center text-gray-500">
            Belum ada gambar diunggah.
          </p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {gambarList.map((item) => (
              <div
                key={item._id}
                className="bg-white rounded shadow p-2 flex flex-col items-center"
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}api/gambardepan/media/${item.gambar.filename}`}
                  alt="Gambar Depan"
                  className="w-full h-48 object-cover rounded"
                />
                <button
                  onClick={() => handleDelete(item._id)}
                  className="mt-2 text-sm text-red-600 hover:text-red-800"
                >
                  Hapus
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListGambarDepan;
